import {
  shallowRef,
  ref,
  nextTick,
  provide,
  type InjectionKey,
  type ShallowRef,
  type Component
} from 'vue'

export const modalsKey = Symbol('modals') as InjectionKey<{
  modalComponent: ShallowRef<Component | undefined>
  mountComponent: (component: Component) => void
  getInstance: () => Promise<Readonly<ShallowRef<any> | null>>
}>

export function provideAppModal() {
  const modalComponent = shallowRef<Component>()
  const modalRef = ref<any>()

  function mountComponent(component: Component) {
    modalComponent.value = component
  }
  async function getInstance() {
    const result = await nextTick(() => {
      return modalRef
    })
    return result
  }

  provide(modalsKey, {
    modalComponent,
    mountComponent,
    getInstance
  })

  return {
    modalRef,
    modalComponent
  }
}
